export type CategoryNames = {
	nameRu: string
	nameUz: string
}

export function getLocalizedCategoryName(
	category: CategoryNames,
	language: unknown,
): string {
	return language === 'uz' ? category.nameUz : category.nameRu
}

/** Returns the API payload only when both required category names are present. */
export function categoryNamesPayload(
	draft: CategoryNames,
): CategoryNames | null {
	const nameRu = draft.nameRu.trim()
	const nameUz = draft.nameUz.trim()
	return nameRu && nameUz ? { nameRu, nameUz } : null
}

export function categoryNamesChanged(
	draft: CategoryNames,
	original: CategoryNames,
): boolean {
	const payload = categoryNamesPayload(draft)
	return Boolean(
		payload &&
			(payload.nameRu !== original.nameRu || payload.nameUz !== original.nameUz),
	)
}
